import React from 'react';

import { useCountdown } from './useCountdown';
import { formatCountdown, getCountdownUnits } from './utils';

export interface CountdownProps {
  endDateTime: string;
}

/**
 * Countdown component that displays the time remaining until a given end date/time
 * @param endDateTime - ISO date string for the end date/time
 */
export const Countdown = ({ endDateTime }: CountdownProps) => {
  const secondsRemaining = useCountdown(endDateTime);
  const countdown = getCountdownUnits(secondsRemaining);
  const formattedCountdown = formatCountdown(countdown);

  return <time dateTime={endDateTime}>{formattedCountdown}</time>;
};
